import { defineComponent } from "vue";
import HomeListTitle from "./homeListTitle.vue";
import PlayList from "@/components/play-list/playList.vue";
export default defineComponent({
  name: "cmdPlayList",
  props: {
    commendList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    return {};
  },
  components: {
    HomeListTitle: HomeListTitle,
    PlayList: PlayList
  }
});